import React, { useState } from "react";
import DashboardLayout from "../dashboard/layout/DashboardLayout";
import { useAuth } from "../../../supabase/auth";
import { Navigate } from "react-router-dom";
import { LoadingScreen } from "../ui/loading-spinner";
import PhoneNumbersList from "../phoneNumbers/PhoneNumbersList";
import { PhoneCall, Plus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../ui/dialog";
import PhoneNumberForm from "../phoneNumbers/PhoneNumberForm";

const PhoneNumbersPage: React.FC = () => {
  const { user, loading } = useAuth();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  
  if (loading) {
    return <LoadingScreen text="Loading..." />;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }
  
  // Define action buttons
  const actionButtons = [
    {
      label: "Add Number",
      onClick: () => setIsDialogOpen(true),
      icon: <PhoneCall size={16} />,
      variant: "default" as const,
      className: "bg-primary hover:bg-primary/80 text-primary-foreground"
    }
  ];

  return (
    <>
      <DashboardLayout
        activeItem="Phone Numbers"
        title="Phone Numbers"
        description="Manage your inbound and outbound phone numbers"
        actionButtons={actionButtons}
      >
        <PhoneNumbersList />
      </DashboardLayout>
      
      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle>Add Phone Number</DialogTitle>
          </DialogHeader>
          <PhoneNumberForm onSuccess={() => setIsDialogOpen(false)} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PhoneNumbersPage;
